import React, { Fragment, useEffect, useRef, useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  Grid,
  Grid2,
  Paper,
  TextField,
  Toolbar,
  Typography,
} from "@mui/material";
import SendOutlinedIcon from "@mui/icons-material/SendOutlined";
import Loading from "../Controller/LoadingController/Loading";
import AppColors from "../Utils/AppColor";
import LogoImageSymbol from "../Assests/SVG/LogoOnly.svg";
import StackedBarChart, {
  StackedBarChartProps,
} from "../Assistance/chatBarChart";
import CommonDataGrid, {
  CommonDataGridProps,
} from "../Assistance/ChatDataTable";
interface Message {
  role: "user" | "assistant";
  content: any;
}
export default function SensorPrompt(): React.ReactElement {
  const [messages, setMessages] = useState<Message[]>([]);
  const [input, setInput] = useState<string>("");
  const [input1, setInput1] = useState<string>(
    "How many complaints resolved within 24 hours? List them all "
  );

  const [loading, setLoading] = useState<boolean>(false);

  // Recommended Prompts
  const recommendedPrompts = [
    "How many times rest rooms are cleaned every day?",
    "List all slots when ammonia level went up more than 0.4",
    "Give me the average number of people in the lobby area",
  ];

  // Scroll to bottom when messages update
  const chatContainerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (chatContainerRef.current) {
      requestAnimationFrame(() => {
        chatContainerRef.current!.scrollTo({
          top: chatContainerRef.current!.scrollHeight,
          behavior: "smooth",
        });
      });
    }
  }, [messages]);

  console.log("messages", messages);

  const sendMessage = async (message: string) => {
    if (input.trim() === "") return;

    const userMessage: Message = { role: "user", content: input };
    setMessages((prevMessages) => [...prevMessages, userMessage]);
    const InputValue = message;
    try {
      setLoading(true);
      setInput("");
      setInput1("");
      const sensor = "sensor";
      const response = await fetch(
        `https://portal.sensz.ai:444/chat/feedback`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization:
              "85fce75037442040b659a78a0c1914344a3de99890160efa6cc25c67abad5aca",
          },
          body: JSON.stringify({ query: InputValue, type: sensor }),
        }
      );
      // let data: {
      //   response: { response: { body: { type: string; message: string } } };
      // } = { response: { response: { body: { type: "", message: "" } } } };

      // if (message === "How many complaints or feedbacks are received?") {
      //   data = {
      //     response: {
      //       response: {
      //         body: {
      //           type: "text",
      //           message:
      //             "There have been a total of 52 complaints or feedbacks received based on the provided complaint data.",
      //         },
      //       },
      //     },
      //   };
      // } else {
      //   data = {
      //     response: {
      //       response: {
      //         body: {
      //           type: "text",

      //           message:
      //             "There are several complaints resolved within 24 hours. Here is the list:\n\n1. NEA-2024-12-030073 - Feedback-Littering-Public Places - Resolved within 24 hours\n2. NEA-2025-01-002731 - Feedback on Cleanliness- Dirty Public Areas(Others) - Resolved within 24 hours\n3. NEA-2025-01-003984 - Feedback on Cleanliness- Drain/Canal-Choked - Resolved within 24 hours\n4. NEA-2025-01-003366 - Feedback on Cleanliness- Dirty Public Areas(Leaves And Branches) - Resolved within 24 hours\n5. NEA-2025.",
      //         },
      //       },
      //     },
      //   };
      // }
      const data = await response.json();
      console.log("data", data);
      // const botMessage: Message = {
      //   role: "assistant",
      //   content: data.message,
      // };
      // setMessages((prevMessages) => [...prevMessages, botMessage]);

      const botMessageContent = Array.isArray(data.message)
        ? data.message[0]
        : "Invalid message format";

      const botMessage: Message = {
        role: "assistant",
        content: botMessageContent,
      };

      setMessages((prevMessages) => [...prevMessages, botMessage]);
    } catch (error) {
      console.error("Error sending message:", error);
    } finally {
      setLoading(false);
    }
  };

  const renderContentData = (message: Message) => {
    console.log("message76678", message);

    let content;
    if (message.content?.type === "table") {
      const tableData = {
        tableResponse: message?.content,
      } as CommonDataGridProps;
      content = <CommonDataGrid tableResponse={tableData.tableResponse} />;
    } else if (message.content?.type === "stackedChart") {
      const stackedChartData = {
        stackedChartResponse: message?.content,
      } as StackedBarChartProps;
      content = (
        <StackedBarChart
          stackedChartResponse={stackedChartData?.stackedChartResponse}
        />
      );
    } else {
      const messageText =
        typeof message.content === "string"
          ? message.content.replace(/\n/g, "<br />")
          : "Invalid message format";

      content = (
        <Typography
          whiteSpace={"pre-wrap"}
          dangerouslySetInnerHTML={{ __html: messageText }}
        />
      );
    }

    return (
      <>
        {/* Row with Image and Message */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, m: 2 }}>
          <Typography>{message?.content?.message}</Typography>
        </Box>

        {content}
      </>
    );
  };

  return (
    <Box sx={{ px: "5px", mt: 10.5 }}>
      <Grid2 container spacing={1}>
        {/* Chat Section (Left - Responsive) */}
        <Grid2
          size={{ xs: 12, sm: 9, md: 8.5, xl: 8.5, lg: 8.5 }}
          sx={{
            display: "flex",
            flexDirection: "column",
            height: "90vh",
            mt: 1,
          }}
        >
          <Box
            ref={chatContainerRef}
            sx={{
              flexGrow: 1, // Takes all available space
              overflowY: "auto",
              p: 2,
              pb: 10,
              scrollbarWidth: "none",
              "&::-webkit-scrollbar": { display: "none" },
            }}
          >
            {messages.map((message, index) => (
              <Box
                key={index}
                sx={{
                  display: "flex",
                  alignItems: "flex-start",
                  justifyContent:
                    message.role === "user" ? "flex-end" : "flex-start",
                }}
              >
                {/* Show Image if not a user message */}
                {message.role !== "user" && (
                  <img
                    src={LogoImageSymbol}
                    alt="icon"
                    style={{
                      width: 24,
                      height: 24,
                      marginTop: 15,
                      marginRight: 8,
                    }}
                  />
                )}

                <Paper
                  elevation={1}
                  sx={{
                    p: 2,
                    bgcolor:
                      message.role === "user"
                        ? AppColors.lightPurple
                        : "#eeeeee",
                    color:
                      message.role === "user" ? AppColors.textPurple : "black",
                    borderRadius: 2,
                    maxWidth: "90%",
                    flexGrow: 1,
                    my: 1,
                  }}
                >
                  {message.role === "user" ? (
                    <Typography color="primary">{message.content}</Typography>
                  ) : (
                    <Fragment>{renderContentData(message)}</Fragment>
                  )}
                </Paper>
              </Box>
            ))}
            {loading && (
              <Loading loading={loading} type="dots" backDrop={false} />
            )}
          </Box>

          {/* Input Section (Fixed at Bottom) */}
          <Box
            component="form"
            onSubmit={(e) => {
              e.preventDefault();
              sendMessage(input);
            }}
            sx={{
              position: "sticky",
              bottom: 0,
              left: 0,
              width: "100%",
              bgcolor: "white",
              borderTop: "1px solid #e0e0e0",
              p: 2,
              display: "flex",
              flexDirection: "column",
              gap: 1,
            }}
          >
            {/* Input & Send Button */}
            <Box sx={{ display: "flex", alignItems: "center", width: "100%" }}>
              <TextField
                fullWidth
                multiline
                placeholder="Type a message..."
                value={input}
                onChange={(e) => setInput(e.target.value)}
                sx={{ mr: 2 }}
              />
              <Button
                variant="contained"
                color="primary"
                disabled={loading}
                onClick={() => sendMessage(input)}
                endIcon={
                  loading ? (
                    <CircularProgress size={24} />
                  ) : (
                    <SendOutlinedIcon />
                  )
                }
              >
                Send
              </Button>
            </Box>

            {/* Copyright Text */}
            <Typography
              variant="caption"
              color="textSecondary"
              textAlign="center"
            >
              © {new Date().getFullYear()} Alai Labs PTE Ltd. All rights
              reserved.
            </Typography>
          </Box>
          <Toolbar />
        </Grid2>

        {/* Recommended Prompts (Right - Responsive) */}
        <Grid2
          className="scrollable-section"
          size={{ xs: 3, sm: 3, md: 3.5, xl: 3.5, lg: 3.5 }}
          sx={{
            height: "85vh",
            bgcolor: "white",
            boxShadow: 3,
            px: 1,
            display: "flex",
            flexDirection: "column",
            overflowY: "auto",
          }}
        >
          <Paper
            elevation={3}
            sx={{
              position: "sticky",
              top: 0, // Adjust as needed
              px: 1,
              py: 1,
              backgroundColor: AppColors.appWhite, // Ensures it doesn't become transparent
              borderRadius: 1,
            }}
          >
            <Typography variant="h6" sx={{ mt: 2 }}>
              Recommended
            </Typography>
          </Paper>
          {recommendedPrompts.map((prompt, index) => (
            <Button
              key={index}
              variant="outlined"
              sx={{ my: 1, wordBreak: "break-word", whiteSpace: "pre-wrap" }}
              onClick={() => setInput(prompt)}
            >
              {prompt}
            </Button>
          ))}
        </Grid2>
      </Grid2>
    </Box>
  );
}
